export enum Environment {
  Local,
  Dev,
  Int,
  Training,
  Qa,
  Con1,
  Con2,
  Con3,
  Prod
}

export const getEnvironment = (): Environment => {
  switch (window.location.hostname.toLowerCase()) {
    case 'creditcheck.int.igssolarpower.com':
      return Environment.Int
    case 'creditcheck.qa.igssolarpower.com':
      return Environment.Qa
    case 'creditcheck.dev.igssolarpower.com':
      return Environment.Dev
    case 'creditcheck.trn.igssolarpower.com':
      return Environment.Training
    case 'creditcheck.con1.igssolarpower.com':
      return Environment.Con1
    case 'creditcheck.con2.igssolarpower.com':
      return Environment.Con2
    case 'creditcheck.con3.igssolarpower.com':
      return Environment.Con3
    case 'creditcheck.igssolarpower.com':
    case 'creditcheck.prod.igssolarpower.com':
      return Environment.Prod
    default:
      return Environment.Local
  }
}



// WEBPACK FOOTER //
// ./src/environmentService.ts